import { render, staticRenderFns } from "./introduce-teams.vue?vue&type=template&id=066e90e0&scoped=true&"
import script from "./introduce-teams.vue?vue&type=script&lang=ts&"
export * from "./introduce-teams.vue?vue&type=script&lang=ts&"
import style0 from "./introduce-teams.vue?vue&type=style&index=0&id=066e90e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e90e0",
  null
  
)

export default component.exports